import type { ElementTheme } from './theme.model';

/**
 * Default element theme with sensible defaults for all element types.
 *
 * Style propagation for composites:
 * - Lines: theme.point → theme.line.vertex → style.vertex → style.vertexPerIndex[i]
 * - Polygons: theme.point → theme.polygon.vertex → style.vertex → style.vertexPerIndex[i]
 * - Polygon borders: theme.line → theme.polygon.border → style.border → style.borderPerEdge[i]
 */
export const DEFAULT_ELEMENT_THEME: ElementTheme = {
  point: {
    size: 5,
    face: 'o',
    color: 'sky',
    fillOpacity: 1,
    strokeWidth: 0,
    visible: true,
  },
  line: {
    color: 'sky',
    strokeWidth: 2,
    dash: 0,
    visible: true,
    straightFirst: false,
    straightLast: false,
    layer: 7,
    vertex: {
      visible: false,
    },
  },
  polygon: {
    fillColor: 'sky',
    fillOpacity: 0.2,
    strokeColor: 'sky',
    strokeWidth: 2,
    vertex: {
      visible: false,
    },
    border: {
      visible: true,
    },
  },
  curve: {
    color: 'sky',
    strokeWidth: 3,
    dash: 0,
    arrows: { first: false, last: false, type: 2, size: 5 },
  },
  angle: {
    fillColor: 'sky',
    fillOpacity: 0.3,
    strokeColor: 'sky',
    radius: 0.3,
    type: 'sector',
  },
  circle: {
    strokeColor: 'sky',
    fillColor: 'sky',
    fillOpacity: 0.1,
    strokeWidth: 2,
    dash: 0,
    center: {
      visible: true,
    },
  },
  arrowAnnotation: {
    line: {
      color: 'neutral',
      strokeWidth: 1.5,
      arrows: { last: true, type: 2, size: 6 },
    },
    label: {
      variant: 'secondary',
    },
  },
};
